export const CANCEL_SUBSCRIPTION_MODAL = 'CANCEL_SUBSCRIPTION_MODAL';
export const RENEW_SUBSCRIPTION_MODAL = 'RENEW_SUBSCRIPTION_MODAL';
export const REPLACE_CARD_TOOLTIP_ID = 'REPLACE_CARD_TOOLTIP_ID';
export const tradeAcceptModal = (id) => `TRADE_ACCEPT_MODAL_${id}`;
export const tradeRejectModal = (id) => `TRADE_REJECT_MODAL_${id}`;
export const tradeCancelModal = (id) => `TRADE_CANCEL_MODAL_${id}`;



// WEBPACK FOOTER //
// ./app/constants/modals.js